
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34589',
  depVersions: {
  "documents-public-ui": "static-1.34589",
  "atom": "static-1.5102",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2527",
  "client-types": "static-1.469",
  "cssUtils": "static-1.798",
  "customer-data-filters-ui": "static-1.39899",
  "customer-data-objects": "static-1.7702",
  "customer-data-property-utils": "static-1.8120",
  "documents-lib": "static-1.34594",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.341",
  "FormsCommonComponents": "static-1.85931",
  "FormUrlGenerator": "static-2.4748",
  "foundations-theming-specialty": "static-1.2165",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5620",
  "hs-test-utils": "static-1.8043",
  "hub-http": "static-1.6251",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11808",
  "HubStyleTokens": "static-2.11501",
  "I18n": "static-7-hdineen_hubspot-i18n-react-compiler.2",
  "icons": "static-2.650",
  "jasmine-immutable": "static-1.3050",
  "jasmine-runner": "static-1.6493",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7185",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5428",
  "quartz": "static-1.7067",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16700",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5367",
  "react-virtualized": "static-2.99",
  "reference-resolvers": "static-1.8200",
  "reference-resolvers-lite": "static-1.8124",
  "reporting-data": "static-1.67675",
  "reporting-reports": "static-1.67353",
  "reporting-snowflake": "static-1.56293",
  "reporting-testing-lib": "static-1.9608",
  "reporting-visualizations": "static-1.59751",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8971",
  "sanitize": "static-1.4505",
  "sanitize-text": "static-1.8172",
  "self-service-api": "static-1.10276",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1776",
  "signup-constants": "static-1.18897",
  "signup-ui-url-generator": "static-2.8081",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4790",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4792",
  "ui-addon-form-validation": "static-1.11019",
  "ui-asset-management-lib": "static-1.11074",
  "ui-images": "static-2.1160",
  "UIComponents": "static-3.8447",
  "usage-tracker": "static-1.7377",
  "usage-tracker-container": "static-1.7367",
  "usage-tracker-core": "static-1.7227",
  "viral-links-lib": "static-1.7095",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9696",
  "foundations-components": "static-1.7990",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.845",
  "quartz-core": "static-1.6286",
  "quick-fetch": "static-1.3939",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4681",
  "ui-addon-i18n": "static-1.11178",
  "ui-addon-upgrades": "static-9.18038",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3421",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3344",
  "quartz-webpack": "static-1.3291",
  "foundations-assets": "static-1.4897",
  "foundations-theming": "static-1.4449",
  "hub-http-shared-msw-handlers": "static-1.10031",
  "hubspotter-http": "static-1.4674",
  "sassPrefix": "static-1.156",
  "events-data-lib": "static-1.253",
  "conversations-skeleton-state": "static-1.7277",
  "crm-message-bus": "static-1.43040",
  "customer-data-filters-ui-msw-helpers": "static-1.22334",
  "customer-data-objects-ui-components": "static-1.13058",
  "customer-data-reference-ui-components": "static-1.13195",
  "customer-data-ui-utilities": "static-1.9855",
  "framework-builder-read-service-client": "static-1.4028",
  "framework-data-schema-quick-fetch": "static-1.6819",
  "framework-data-schema-resolvers": "static-1.6914",
  "inbound-db-meta-service-client": "static-1.3609",
  "inbound-db-properties-service-client": "static-1.3869",
  "multi-account-reference-resolvers": "static-1.1009",
  "onboarding-tours": "static-1.16666",
  "reporting-datasets-permissions-lib": "static-1.13764",
  "ui-addon-teams": "static-1.21595",
  "quartz-auth": "static-1.742",
  "ui-business-units-lib": "static-1.9084",
  "usage-tracker-session-replay": "static-1.5063",
  "ai-components-ui-library": "static-1.9042",
  "ContentUtils": "static-1.68449",
  "customer-data-properties": "static-1.51667",
  "forms-ai-lib": "static-1.4360",
  "forms-utils-lib": "static-1.12635",
  "foundations-components-test-utils": "static-1.5473",
  "react-dnd-compat": "static-1.4644",
  "react-tinymce": "static-1.55323",
  "tinymce-config": "static-2.54449",
  "ui-gdpr-components": "static-1.10379",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3434",
  "HeadJS": "static-2.764",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3154",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.103",
  "ui-fonts": "static-1.763",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4356",
  "csstype": "static-1.50",
  "quartz-head": "static-1.732",
  "web-vitals": "static-1.6",
  "batch-promise": "static-1.1571",
  "external-options-client-types": "static-1.4182",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.742",
  "frontend-preferences-client": "static-1.7956",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "persist-promise": "static-1.3728",
  "reporting-client-types": "static-1.2504",
  "apollo-stack-hubspot": "static-3.86",
  "growth-payments-core": "static-1.25459",
  "hubspot-apollo-client": "static-1.4908",
  "foundations-components-legacy": "static-1.1015",
  "merchandise-lib": "static-1.264",
  "quartz-routing": "static-1.497",
  "hs-story-utils": "static-1.9453",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.255",
  "timezone-utils": "static-2.5274",
  "seat-types-lib": "static-1.77",
  "bend-plugin-foundations-components": "static-1.4259",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2030",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-test": "static-1.742",
  "quartz-tracking": "static-1.446",
  "bend-plugin-chirp-manifest": "static-1.91",
  "chirp-fetch": "static-1.1917",
  "purchase-motions-components": "static-1.5969",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4103",
  "bender-build-tools": "static-1.3215",
  "bend-plugin-foundations-theming": "static-1.2932",
  "stylex": "static-1.33",
  "hs-resources": "static-1.183",
  "pulse": "static-1.608",
  "restore-request-side-panel-lib": "static-1.975",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3820",
  "crm-pipelines-api-client-types": "static-1.4162",
  "fdsr-migration-layer": "static-1.33",
  "multi-currency-client-types": "static-1.3714",
  "getting-started-shared-tasks": "static-1.18527",
  "growth-data-modal": "static-1.5471",
  "growth-onboarding-confetti": "static-1.3096",
  "growth-onboarding-next-action-utils": "static-1.2001",
  "navigation-components": "static-1.18113",
  "onboarding-tours-client": "static-1.4880",
  "onboarding-tours-utils": "static-1.732",
  "ui-shepherd-react": "static-3.10200",
  "ui-shepherd-tracker": "static-1.7581",
  "ui-universal-auth": "static-1.9012",
  "user-context": "static-1.5134",
  "hubspotter-http-shared-msw-handlers": "static-1.10029",
  "magpie-lib": "static-1.5571",
  "navigation-messaging": "static-1.7440",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21415",
  "copilot-toolkit": "static-1.11206",
  "cms-field-types": "static-1.4841",
  "content-icons-ui": "static-1.2233",
  "integrations-lib": "static-1.16249",
  "calling-global-api": "static-1.64608",
  "calling-internal-common": "static-1.31331",
  "calling-lifecycle-internal": "static-1.65990",
  "calling-lifecycle-messages": "static-1.58284",
  "commerce-products-lib": "static-1.9670",
  "crm-links": "static-1.6324",
  "customer-data-properties-shared-msw-handlers": "static-1.9358",
  "file-manager-components": "static-1.23699",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4246",
  "meetings-icalendar-utils-lib": "static-1.661",
  "object-builder-ui-client": "static-1.48837",
  "pipeline-validation-client-types": "static-1.3988",
  "property-value-citations": "static-1.2281",
  "smart-property-lib": "static-1.7229",
  "tiered-pricing": "static-1.1280",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9089",
  "final-form": "static-1.70",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19880",
  "tinymce-themes": "static-1.56419",
  "data-token-picker": "static-1.16454",
  "hub-http-contrib": "static-1.3071",
  "interframe": "static-3.4789",
  "tinymce-data": "static-1.40534",
  "tinymce-plugins": "static-1.57563",
  "ui-addon-sales-email": "static-1.5240",
  "onboarding-scopes": "static-1.6490",
  "ui-addon-opt": "static-4.8393",
  "apollo-link-hub-http": "static-2.4681",
  "hubspot-apollo-cache": "static-1.367",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.201",
  "purchase-motions-api": "static-1.5972",
  "bend-plugin-pulse": "static-1.111",
  "event-emitter": "static-1.977",
  "fast-json-patch": "static-1.63",
  "onboarding-data-sync-lib": "static-1.2000",
  "growth-onboarding-next-action-components": "static-1.2029",
  "user-context-client": "static-1.4641",
  "idb-keyval": "static-1.44",
  "magpie-types": "static-1.5031",
  "nest": "static-1.259",
  "reactive-lib": "static-1.752",
  "simple-logging-lib": "static-1.3080",
  "unified-auth-core-lib": "static-1.808",
  "getting-started-shared-tasks-store": "static-1.17645",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13664",
  "integrations-tracking-lib": "static-1.5631",
  "native-integrations-shared-strings": "static-1.7811",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10395",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.526",
  "calling-error-reporting": "static-1.31338",
  "shared-worker-versioning": "static-1.11066",
  "calling-usage-tracker": "static-1.6570",
  "voice-sms-access-library": "static-1.1098",
  "customer-data-tracking": "static-1.6919",
  "commerce-permissions": "static-1.800",
  "products-iframe-lib": "static-1.8015",
  "products-ui-components-shared-msw-handlers": "static-1.10413",
  "location-customization-utils-lib": "static-1.9345",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4183",
  "video-components-external": "static-1.11377",
  "video-data-lib": "static-1.35035",
  "data-agent-kit": "static-1.238",
  "feedback-loader": "static-1.29348",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10114",
  "fsm": "static-1.3761",
  "policy-lib": "static-1.6806",
  "react-colorpicker": "static-2.10237",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10177",
  "FileManagerLib": "static-1.39339",
  "NamespacedHubStyle": "static-2.9081",
  "FileManagerCore": "static-1.39198",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7794",
  "layout-dnd-components": "static-1.12497",
  "layout-dnd-utils": "static-1.11472",
  "react-codemirror": "static-1.10655",
  "ui-addon-emoji-picker": "static-1.9917",
  "ui-brand-identity-lib": "static-1.15404",
  "InboxConnectUtils": "static-4.14893",
  "meetings-connect-utils-lib": "static-1.7634",
  "universal-page-editor-lib": "static-1.3042",
  "google-sheets-integration-lib": "static-1.322",
  "microsoft-drive-integration-lib": "static-1.446",
  "slack-ui-library": "static-1.10421",
  "calling-orchestration-schema": "static-1.35875",
  "sales-views-client-types": "static-1.4288",
  "crm-record-cards-service-types": "static-1.3615",
  "content-media-composition-data-lib": "static-1.12424",
  "content-media-compositions": "static-2.16431",
  "media-bridge-lib": "static-1.18973",
  "trellis-story-utils": "static-1.4544",
  "storybook-react": "static-1.33",
  "audio-components": "static-1.5957",
  "FileManagerImages": "static-1.36850",
  "video-components": "static-1.13380",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4566",
  "video-embed": "static-1.35869",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8732",
  "ui-coaching-tips": "static-1.28640",
  "ContentData": "static-1.68524",
  "layout-data-lib": "static-1.9797",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22190",
  "outpost": "static-1.4207",
  "growth-onboarding-feedback-components": "static-1.6609",
  "advanced-menus-core": "static-1.15171",
  "advanced-menus-lib": "static-1.12109",
  "ExportDialog": "static-6.10413",
  "ui-memberships-settings-lib": "static-1.34124",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15170",
  "simple-menus-lib": "static-1.16687"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34589",
  "atom": "/atom/static-1.5102",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2527",
  "client-types": "/client-types/static-1.469",
  "cssUtils": "/cssUtils/static-1.798",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39899",
  "customer-data-objects": "/customer-data-objects/static-1.7702",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8120",
  "documents-lib": "/documents-lib/static-1.34594",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.341",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85931",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4748",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2165",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5620",
  "hs-test-utils": "/hs-test-utils/static-1.8043",
  "hub-http": "/hub-http/static-1.6251",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11808",
  "HubStyleTokens": "/HubStyleTokens/static-2.11501",
  "I18n": "/I18n/static-7-hdineen_hubspot-i18n-react-compiler.2",
  "icons": "/icons/static-2.650",
  "jasmine-immutable": "/jasmine-immutable/static-1.3050",
  "jasmine-runner": "/jasmine-runner/static-1.6493",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7185",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5428",
  "quartz": "/quartz/static-1.7067",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16700",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5367",
  "react-virtualized": "/react-virtualized/static-2.99",
  "reference-resolvers": "/reference-resolvers/static-1.8200",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8124",
  "reporting-data": "/reporting-data/static-1.67675",
  "reporting-reports": "/reporting-reports/static-1.67353",
  "reporting-snowflake": "/reporting-snowflake/static-1.56293",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9608",
  "reporting-visualizations": "/reporting-visualizations/static-1.59751",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8971",
  "sanitize": "/sanitize/static-1.4505",
  "sanitize-text": "/sanitize-text/static-1.8172",
  "self-service-api": "/self-service-api/static-1.10276",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1776",
  "signup-constants": "/signup-constants/static-1.18897",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8081",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4790",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4792",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11019",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11074",
  "ui-images": "/ui-images/static-2.1160",
  "UIComponents": "/UIComponents/static-3.8447",
  "usage-tracker": "/usage-tracker/static-1.7377",
  "usage-tracker-container": "/usage-tracker-container/static-1.7367",
  "usage-tracker-core": "/usage-tracker-core/static-1.7227",
  "viral-links-lib": "/viral-links-lib/static-1.7095",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9696",
  "foundations-components": "/foundations-components/static-1.7990",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.845",
  "quartz-core": "/quartz-core/static-1.6286",
  "quick-fetch": "/quick-fetch/static-1.3939",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4681",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11178",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18038",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3421",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3344",
  "quartz-webpack": "/quartz-webpack/static-1.3291",
  "foundations-assets": "/foundations-assets/static-1.4897",
  "foundations-theming": "/foundations-theming/static-1.4449",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10031",
  "hubspotter-http": "/hubspotter-http/static-1.4674",
  "sassPrefix": "/sassPrefix/static-1.156",
  "events-data-lib": "/events-data-lib/static-1.253",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7277",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22334",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13058",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13195",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9855",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4028",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6819",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6914",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3609",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3869",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1009",
  "onboarding-tours": "/onboarding-tours/static-1.16666",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13764",
  "ui-addon-teams": "/ui-addon-teams/static-1.21595",
  "quartz-auth": "/quartz-auth/static-1.742",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9084",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5063",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9042",
  "ContentUtils": "/ContentUtils/static-1.68449",
  "customer-data-properties": "/customer-data-properties/static-1.51667",
  "forms-ai-lib": "/forms-ai-lib/static-1.4360",
  "forms-utils-lib": "/forms-utils-lib/static-1.12635",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5473",
  "react-dnd-compat": "/react-dnd-compat/static-1.4644",
  "react-tinymce": "/react-tinymce/static-1.55323",
  "tinymce-config": "/tinymce-config/static-2.54449",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10379",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3434",
  "HeadJS": "/HeadJS/static-2.764",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3154",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.103",
  "ui-fonts": "/ui-fonts/static-1.763",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4356",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.732",
  "web-vitals": "/web-vitals/static-1.6",
  "batch-promise": "/batch-promise/static-1.1571",
  "external-options-client-types": "/external-options-client-types/static-1.4182",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.742",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7956",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3728",
  "reporting-client-types": "/reporting-client-types/static-1.2504",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "growth-payments-core": "/growth-payments-core/static-1.25459",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4908",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1015",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "quartz-routing": "/quartz-routing/static-1.497",
  "hs-story-utils": "/hs-story-utils/static-1.9453",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.255",
  "timezone-utils": "/timezone-utils/static-2.5274",
  "seat-types-lib": "/seat-types-lib/static-1.77",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4259",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2030",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-test": "/quartz-test/static-1.742",
  "quartz-tracking": "/quartz-tracking/static-1.446",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.91",
  "chirp-fetch": "/chirp-fetch/static-1.1917",
  "purchase-motions-components": "/purchase-motions-components/static-1.5969",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4103",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2932",
  "stylex": "/stylex/static-1.33",
  "hs-resources": "/hs-resources/static-1.183",
  "pulse": "/pulse/static-1.608",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.975",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3820",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4162",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.33",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3714",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18527",
  "growth-data-modal": "/growth-data-modal/static-1.5471",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3096",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2001",
  "navigation-components": "/navigation-components/static-1.18113",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4880",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.732",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10200",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7581",
  "ui-universal-auth": "/ui-universal-auth/static-1.9012",
  "user-context": "/user-context/static-1.5134",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10029",
  "magpie-lib": "/magpie-lib/static-1.5571",
  "navigation-messaging": "/navigation-messaging/static-1.7440",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21415",
  "copilot-toolkit": "/copilot-toolkit/static-1.11206",
  "cms-field-types": "/cms-field-types/static-1.4841",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "integrations-lib": "/integrations-lib/static-1.16249",
  "calling-global-api": "/calling-global-api/static-1.64608",
  "calling-internal-common": "/calling-internal-common/static-1.31331",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65990",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58284",
  "commerce-products-lib": "/commerce-products-lib/static-1.9670",
  "crm-links": "/crm-links/static-1.6324",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9358",
  "file-manager-components": "/file-manager-components/static-1.23699",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4246",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.661",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48837",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3988",
  "property-value-citations": "/property-value-citations/static-1.2281",
  "smart-property-lib": "/smart-property-lib/static-1.7229",
  "tiered-pricing": "/tiered-pricing/static-1.1280",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9089",
  "final-form": "/final-form/static-1.70",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19880",
  "tinymce-themes": "/tinymce-themes/static-1.56419",
  "data-token-picker": "/data-token-picker/static-1.16454",
  "hub-http-contrib": "/hub-http-contrib/static-1.3071",
  "interframe": "/interframe/static-3.4789",
  "tinymce-data": "/tinymce-data/static-1.40534",
  "tinymce-plugins": "/tinymce-plugins/static-1.57563",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5240",
  "onboarding-scopes": "/onboarding-scopes/static-1.6490",
  "ui-addon-opt": "/ui-addon-opt/static-4.8393",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4681",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.367",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.201",
  "purchase-motions-api": "/purchase-motions-api/static-1.5972",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.111",
  "event-emitter": "/event-emitter/static-1.977",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2000",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2029",
  "user-context-client": "/user-context-client/static-1.4641",
  "idb-keyval": "/idb-keyval/static-1.44",
  "magpie-types": "/magpie-types/static-1.5031",
  "nest": "/nest/static-1.259",
  "reactive-lib": "/reactive-lib/static-1.752",
  "simple-logging-lib": "/simple-logging-lib/static-1.3080",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.808",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17645",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13664",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5631",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7811",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10395",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.526",
  "calling-error-reporting": "/calling-error-reporting/static-1.31338",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11066",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6570",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1098",
  "customer-data-tracking": "/customer-data-tracking/static-1.6919",
  "commerce-permissions": "/commerce-permissions/static-1.800",
  "products-iframe-lib": "/products-iframe-lib/static-1.8015",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10413",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9345",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4183",
  "video-components-external": "/video-components-external/static-1.11377",
  "video-data-lib": "/video-data-lib/static-1.35035",
  "data-agent-kit": "/data-agent-kit/static-1.238",
  "feedback-loader": "/feedback-loader/static-1.29348",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10114",
  "fsm": "/fsm/static-1.3761",
  "policy-lib": "/policy-lib/static-1.6806",
  "react-colorpicker": "/react-colorpicker/static-2.10237",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10177",
  "FileManagerLib": "/FileManagerLib/static-1.39339",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9081",
  "FileManagerCore": "/FileManagerCore/static-1.39198",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7794",
  "layout-dnd-components": "/layout-dnd-components/static-1.12497",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11472",
  "react-codemirror": "/react-codemirror/static-1.10655",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9917",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15404",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14893",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7634",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3042",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.322",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.446",
  "slack-ui-library": "/slack-ui-library/static-1.10421",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35875",
  "sales-views-client-types": "/sales-views-client-types/static-1.4288",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12424",
  "content-media-compositions": "/content-media-compositions/static-2.16431",
  "media-bridge-lib": "/media-bridge-lib/static-1.18973",
  "trellis-story-utils": "/trellis-story-utils/static-1.4544",
  "storybook-react": "/storybook-react/static-1.33",
  "audio-components": "/audio-components/static-1.5957",
  "FileManagerImages": "/FileManagerImages/static-1.36850",
  "video-components": "/video-components/static-1.13380",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4566",
  "video-embed": "/video-embed/static-1.35869",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8732",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28640",
  "ContentData": "/ContentData/static-1.68524",
  "layout-data-lib": "/layout-data-lib/static-1.9797",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22190",
  "outpost": "/outpost/static-1.4207",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6609",
  "advanced-menus-core": "/advanced-menus-core/static-1.15171",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12109",
  "ExportDialog": "/ExportDialog/static-6.10413",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34124",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15170",
  "simple-menus-lib": "/simple-menus-lib/static-1.16687"
}
};
